/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import StructureFind from '@components/structure-search/structure-find';
import { EuiHeader, EuiHeaderSectionItem, EuiText } from '@elastic/eui';
import { PVTContext } from '@lib/context/pvt.context';
import { Structure } from '@lib/domain/stuctures';
import router from 'next/router';
import { FunctionComponent, useContext, useEffect, useState } from 'react';
import { UserBadge } from './user-badge';

export const HeaderPrimary: FunctionComponent<{
  showSearch?: boolean;
}> = ({ showSearch = false }) => {
  const { setStructure, setTablePage, setOffset } = useContext(PVTContext);
  const [selectedStructures, setSelectedStructures] = useState<Structure[]>([]);

  useEffect(() => {
    if (!Array.isArray(selectedStructures)) return;
    const struct = selectedStructures[0];
    if (!struct) return;
    setStructure({ type: struct.type, code: struct.code });
  }, [selectedStructures]);
  const sections = [
    {
      items: [
        <EuiHeaderSectionItem key="da-logo">
          <img
            onClick={() => router.push('/')}
            style={{ cursor: 'pointer' }}
            src="/images/logo-with-white-text.svg"
            alt="DA Logo"
            width="70px"
          />{' '}
        </EuiHeaderSectionItem>,
        <EuiText
          key="app-title"
          size="m"
          color="white"
          css={{
            marginLeft: '10px',
            paddingLeft: '10px',
            opacity: 0.6,
            borderLeft: '1px solid #ffffff50',
          }}>
          <strong>PVT</strong>
        </EuiText>,
      ],
    },
  ];
  if (showSearch) {
    sections.push({
      //items: [<EuiSearchBar key="search-bar" />],
      items: [
        <div key="struct-find-key" style={{ minWidth: 500, marginBottom: 8 }}>
          <StructureFind
            singleSelection={true}
            value={selectedStructures}
            onChange={structures => {
              setSelectedStructures(structures);
              setTablePage(0);
              setOffset(0);
            }}
          />
        </div>,
      ],
    });
  }
  sections.push({
    items: [<UserBadge key="user-badge" />],
  });

  return (
    <EuiHeader
      theme="dark"
      position="fixed"
      className="main-header"
      sections={sections}></EuiHeader>
  );
};
